export default "__VITE_ASSET__9d80901f__"